import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBasicByCategory } from '../api';
export default {
  name: 'categoryBasic',
  props: {
    disabled: Boolean,
    styleId: [String, Number],
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 默认主题色
      defaultThemeColor: '#c20c0c',
      // 主题色预置色块
      predefineColors: ['#c20c0c', '#ff5a5f', '#ff8c00', '#ffc300', '#12b76a', '#0d68ff', '#7a5af8', '#ed4aa1'],
      rules: {
        home_index_name: [{
          required: true,
          message: '标题名称不可为空',
          trigger: 'change'
        }],
        menus_page_style: [{
          required: true,
          message: '菜单模式不可为空',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    // 切换菜单模式后回调
    changeMenuStyle: function changeMenuStyle(val) {
      this.$emit('onChangeMenuStyle', val);
    },
    // 输入框颜色值格式校验与补全
    formatThemeColor: function formatThemeColor() {
      var color = (this.value.menus_page_theme_color || '').trim();
      if (color && !color.startsWith('#')) {
        color = "#".concat(color);
      }
      var isValid = /^#[0-9a-fA-F]{6}$/.test(color);
      if (!isValid) {
        this.$message.warning('请输入6位十六进制颜色值，如 #c20c0c');
        this.value.menus_page_theme_color = this.defaultThemeColor;
        return;
      }
      this.value.menus_page_theme_color = color;
    },
    // 重置为默认主题色
    resetThemeColor: function resetThemeColor() {
      this.value.menus_page_theme_color = this.defaultThemeColor;
    },
    loadData: function loadData() {
      var _this = this;
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var module = this.info.module;
      return new Promise(function (resolve) {
        getBasicByCategory(_objectSpread({
          style_id: _this.styleId
        }, params), module, methods).then(function (res) {
          resolve(_objectSpread(_objectSpread({}, _this.value), res.data)); // 顺序不可换;
        });
      });
    },
    toSave: function toSave() {
      var _this2 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var data;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return _this2.loadData('post', _this2.value);
              case 1:
                data = _context.v;
                _this2.$message({
                  type: 'success',
                  message: '保存成功'
                });
                _this2.$emit('onSave', data);
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  computed: {
    // 是否客户级装修
    isCustomer: function isCustomer() {
      return ['custom', 'plat_custom', 'service_custom', 'plat_service_custom'].includes(this.info.module);
    },
    // 可配置显示风格与主题色（三种菜单模式均支持）
    canConfigStyle: function canConfigStyle() {
      return [2, 3, 4].includes(this.value.menus_page_style);
    }
  }
  // async created() {
  // 	const data = await this.loadData()
  // 	Object.keys(this.value).forEach(key => {
  // 		this.value[key] = data[key]
  // 	})
  // }
};